
export const LOGIN = "/login";
export const HOME = "/";
export const NYUUKA = "/nyuuka";
export const NYUUKA_DETAIL = "/nyuuka/detail";
export const SHUKKA = "/shukka";
export const SHUKKA_DETAIL = "/shukka/detail";
export const ZAIKO_JAN_LIST = "/zaiko";
export const ZAIKO_EPC_LIST = "/zaiko/epc";
export const ZAIKO_EPC_EVENT_LIST = "/zaiko/epc/event";
export const TANAOROSHI = "/tanaoroshi";
export const TANAOROSHI_SAI = "/tanaoroshi/sai";
export const TANAOROSHI_ADJUSTMENT_HISTORY = "/tanaoroshi/adjustment/history";
export const USER = "/user";
export const DASHBOARD = "/dashboard";
export const ZAIKO_MOVE = "/zaiko-move";
export const ZAIKO_MOVE_DETAIL = "/zaiko-move/detail";
export const SALES = "/sales";
export const ALARM_EVENTS = "/alarm";
export const SITEZONE = "/sitezone";
export const TANAOROSHI_LIST = "/tanaoroshiList";
export const TANAOROSHI_PRODUCTCODE_LIST = "/tanaoroshiList/productCode";
export const TANAOROSHI_SKU_LIST = "/tanaoroshiList/productCode/sku";
export const COOPERATION_FILE_UPLOAD = "/cooperation-file-upload";
export const PEOPLE_COUNTER = "/people-counter";
export const EAS_PASSAGE = "/eas-passage";
export const POS_MOVEMENTS = "/pos-movements";

export const Paths = {
    LOGIN,
    HOME,
    NYUUKA,
    NYUUKA_DETAIL,
    SHUKKA,
    SHUKKA_DETAIL,
    ZAIKO_JAN_LIST,
    ZAIKO_EPC_LIST,
    ZAIKO_EPC_EVENT_LIST,
    TANAOROSHI,
    TANAOROSHI_SAI,
    TANAOROSHI_ADJUSTMENT_HISTORY,
    USER,
    DASHBOARD,
    ZAIKO_MOVE,
    ZAIKO_MOVE_DETAIL,
    SALES,
    ALARM_EVENTS,
    SITEZONE,
    TANAOROSHI_LIST,
    TANAOROSHI_PRODUCTCODE_LIST,
    TANAOROSHI_SKU_LIST,
    COOPERATION_FILE_UPLOAD,
    PEOPLE_COUNTER,
    EAS_PASSAGE,
    POS_MOVEMENTS
}

export default Paths;
